import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import sal from "sal.js";
import AllFeatures from "../../Components/AllFeatures";
import { Helmet } from "@dr.pogodin/react-helmet";
import MinPlanPrice from "../../Components/MinPlanPrice";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function StreamingServerLosAngeles() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Streaming Server Montreal – Reliable & Fast Hosting Solution";
        sal();
      }, []);
   const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
    <Helmet>
        <title>Streaming Server Montreal – Reliable & Fast Hosting Solution</title>
        <meta name="description" content="Get a high-performance streaming server montreal with low latency, smooth live streaming, and reliable bandwidth for OTT, gaming, and media platforms worldwide." />
        <meta name="keywords" content="Web Streaming Service, Streaming server los angeles, Personal Streaming Service, Best Streaming Server, Streaming Server Cost, Best Server For Streaming, Best Stream Server, Live Streaming Server, Open Streaming Server, Self Hosted Streaming, Server For Streaming Media, Server Streaming Open Source, Set Up A Streaming Server, Streaming Server Hosting Cost, Streaming Server Hosting, Media Streaming Server, Stream Server, Streaming Server Windows, Live Stream Server, Streaming Web Server, Web Server Streaming, Streaming-Server, Vod Server" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/streaming-server-los-angeles`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/streaming-server-los-angeles`} />
        <meta property="og:title" content="Streaming Server in Los Angeles: 4K & HD Streaming Enhanced" />
        <meta property="og:description" content="Stream in 4K or HD smoothly with our dedicated streaming server in Los Angeles. Get high-quality, uninterrupted video delivery to your global customer base." />
      </Helmet>
    <div className="wordpress-hosting-banner about-banner pb-120 bg-dark">
          <div className="container">
              <div className="row g-4 align-items-center align-items-xxl-end">
                  <div className="col-lg-7">
                      <div className="d-flex align-items-center gap-2">
                          <div className="w-3 h-3 rounded-circle bg-primary flex-shrink-0"></div>
                          <span className="d-block fw-semibold mb-0 text-primary">
                              Streaming Server Los Angeles
                          </span>
                      </div>
                      <h1 className="mb-6 text-white">
                          From ‘Stream’ to ‘Must-Watch’: With Streaming Server Los Angeles
                      </h1>
                      <p className="text-white max-text-60 mb-8 text-opacity-75">
                          Viewers decide in a few seconds only, so lag isn't an option. Make every live moment count with outstanding performance from our Streaming Server Los Angeles. Are you ready to see how high-level streaming really feels?
                      </p>
                      <div className="d-flex align-items-center flex-wrap gap-4">
                          <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-semibold rounded btn-height">
                              <span className="btn-arrow__text">
                                  Free Trial
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                          </Link>
                          <button onClick={handlePlanClick} className="btn btn-light btn-arrow btn-lg fs-14 fw-semibold rounded transition btn-height">
                            <span className="btn-arrow__text">
                                Explore
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </button>
                        <MinPlanPrice category="customizedssls" />
                      </div>
                      <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                  </div>
                  <div className="col-lg-5 ipad-mt">
                      <div className="about-banner__img">
                          <img src="images/from-stream-to-must-watch.webp" alt="image" className="img-fluid full-width-img" />
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <section className="bg-white pt-120 pb-100">
        <div className="container">
            <div className="row align-items-center justify-content-between g-4">
                <div className="col-xl-6 col-lg-10">
                  <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>No Buffering. No Lag. No Glitch.</small>
                    <h2 className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Lag Left The Chat. Los Angeles Server Didn’t.</h2>
                </div>
            </div>
            <div className="mt-8">
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/control-every.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Control Every Frame</h6>
                            <p className="mb-0">Easily install and manage your server setup to meet your business’s changing demands-stay scalable, stay in charge.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/flex-your-stream.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Flex Your Stream</h6>
                            <p className="mb-0">Get complete freedom with a streaming server that helps you go live with the help of any device, from any location.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/built-for-more.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Built for More Stability</h6>
                            <p className="mb-0">Get highly balanced performance along with a dedicated streaming server that always keeps your stream seamless.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <section className="price-plan-section pt-100 pb-100">
          <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
          <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Your Flow. Your Conditions. Our Tech.</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'customizedssls'}/>
      </section>

      <section className="simple-box-section pt-100 pb-100">
      <div className="container">
        <div className="row">
            <div className="col-12">
                <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card-body px-6 pt-60 pb-60">
                        <div className="row justify-content-center">
                            <div className="col-md-11 col-lg-8 col-xl-8">
                                <div className="text-center">
                                  <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Next-Gen LA Streams</span>
                                    <h4 className="mb-4">
                                        From LA: Stream Like You Were Born For It.
                                    </h4>
                                    <p className="mb-6">
                                      Go beyond complex setups-our live streaming server in Los Angeles is engineered around you. Even if it’s a live event, online seminar, or content race, get performance that scales with your stream style. 
                                    </p>
                                    <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                        <span className="d-inline-block me-1 flex-shrink-0">
                                            <i className="las la-comments"></i>
                                        </span>
                                        <span className="btn-arrow__text">
                                            +91-7737300013
                                            <span className="btn-arrow__icon">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </span>
                                    </Link>
                                    <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                        <span className="d-inline-block me-1 flex-shrink-0">
                                            <i className="las la-comments"></i>
                                        </span>
                                        <span className="btn-arrow__text">
                                            Talk to an Expert
                                            <span className="btn-arrow__icon">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </section>

    <section className="bg-dark pt-100 pb-100 position-relative allfeatures-wrapper">
        <img src="images/service_16_shape_2.png" alt="Image" className="img-fluid position-absolute start-0 bottom-0 pattern-bg-img"></img>
        <div className="pb-40">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-10 col-xl-7">
                        <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          <span className="section-title-dark style-bg fadeInUp">Perks of LA Server</span>
                            <h2 className="text-white">
                                Complete Hosting Solutions
                            </h2>
                            <p className="mb-0 text-white max-text-52 mx-auto text-opacity-75">
                                All-in-one hosting with speed, security, support, and tools for smooth website management.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AllFeatures />
      </section>

      <section className="pt-100 pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Stream Without Cuts
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get More Than Just a Streaming Server: Check the Additions</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">No Frills. Just High Speed.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/no-slow-speeds-just-10-Gbps.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Launch quickly with our intuitive UI, CLI, and API-no challenging setup needed. Ideal for small groups on the move.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Live = Instantly with Us</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/live-are-you-sure.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Connect in no time with live streaming server solutions that offer ultra-low latency for genuine real-time experiences..</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Bigger Audience? Bring It On.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/big-audiences.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Our streaming dedicated server Los Angeles easily scales with your niche audience-just 0.05s latency and smooth.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">No Attacks Allowed</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/no-attacks-allowed.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Always stay protected with a shield-our built-in DDoS protection that effortlessly blocks threats in under 10 seconds.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Voice + Video = Ideal Sync</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/audio-video.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Integrate high-quality calls to your application along with our SDKs. Crafted to perform on any streaming server Los Angeles.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Eyes Everywhere, Instantly</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/eyes-everywhere.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Install ONVIF IP cameras directly into your app. Our live server supports audio check for smarter observation.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="pb-100">
      <div className="">
        <div className="container">
          <div className="card cta-wrapper-one domain-container-inner rounded-3">
            <div className="card-body p-md-6 p-xl-10">
              <div className="g-4 align-items-center">
                <div className="text-center">
                <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Stream City LA</small>
                  <h5 className="mt-3 mb-4">
                      From Server to Your Screen: How We Keep Its Backend Smooth
                  </h5>
                  <p className="">
                      Get buffer-free, hassle-free, high-resolution video on any type of device. With the help of pre-installed and completely configured servers,
                      Infinitive Host always makes streaming comfortable, quick, secure, and trustworthy.
                      Need support? Our 24/7 expert team has your back-always, no matter what.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 pt-60">
              <img src="images/behind-the-scene-streaming.webp" alt="image" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>

    <section className="pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Why Streamers Pick Infinitive Host LA
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Why Live Streamers Rate Our Los Angeles Server</h2>
                        <p className="text-dark mb-0 max-text-56 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Because Your Target Audience Deserves Smooth Streaming</p>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">No Setup Charges</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/free-setup-every-time.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Why wait for too long or pay extra? Get started instantly-the whole setup’s on us!</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Your Stream’s Shield</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/encrypted-&-secure.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">No more worries-your stream stays protected from hacks, threats, and suspicious stuff.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Real People Support</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/real-people-support.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Are you stuck with lag? We’re just a message away, always ready to connect.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Your Stream, Non-Stop</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/non-stop-live-stream.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">99.9% network uptime guaranteed; make sure that your business is always up.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Scale Up in Seconds</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/scale-up-in-seconds.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Going viral in no time? We understand you. Your stream grows as quickly as your viewers.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Oops-Proof Storage</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/oops-proof-storage.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Lost files? No chance, We’ve got every day, weekly & monthly backups on time.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>

        <div className="pb-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-8 col-xl-6">
                        <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Scalability? Yes!!</small>
                            <h2 className="mb-4">
                                Hit Play: We’re Ready When You Are
                            </h2>
                            <p className="mb-8 max-text-52 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Streaming, Upgraded: No Limits, Just Pure Performance
                            </p>
                            <div className="d-flex flex-wrap justify-content-center align-items-center gap-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <Link to="#" onClick={handlePlanClick} className="btn btn-lg btn-primary btn-arrow fs-14 fw-medium rounded btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                        <i className="las la-comment-dots"></i>
                                    </span>
                                    <span className="btn-arrow__text">
                                        Get Started
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                                <Link to="#" className="btn btn-lg btn-dark btn-arrow fs-14 fw-medium rounded open-live-chat btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                        <i className="las la-comment-dots"></i>
                                    </span>
                                    <span className="btn-arrow__text">
                                        Talk to an Expert
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  );
}
